module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state !== 0),
      expression: "state !== 0"
    }]
  }, [(!_vm.showKittens) ? _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-fluid rounded",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#workoutModal",
      "src": _vm.chosenWorkout.picture,
      "alt": _vm.chosenWorkout.name
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.chosenWorkout.name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "countdown-holder"
  }, [_c('count-down-timer', {
    ref: "countdowntimer",
    attrs: {
      "time": _vm.time
    },
    on: {
      "finished": _vm.togglePomodoro
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34204942","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timer/Pomodoro.vue
// module id = 49
// module chunks = 0